var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empty flex-column-center"},[_c('div',{staticClass:"empty-img"},[_c('img',{style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":require("@/assets/list.png"),"alt":""}})]),_c('div',{staticClass:"empty-title"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }